export default __webpack_public_path__ + "static/media/500-600.6462fb84.jpg";